import { DataType } from '@/core/interfaces/common';

import { ArticleLink as ArticleLinkType } from '@/features/Articles/Articles.types';
import { MediaLink as MediaLinkType } from '@/features/Media/media.types';
import { MomentLink as MomentLinkType } from '@/features/Search';

import { ResourceType } from './resourceLink.types';
import { ArticleLink } from './ArticleLink';
import { MediaLink } from './MediaLink';
import { MomentLink } from './MomentLink';

type ResourceLinkProps = {
  data: DataType<MediaLinkType | MomentLinkType | ArticleLinkType>;
  type?: ResourceType;
  isSearchResult?: boolean;
}

const renderLinkComponent = (
  type: ResourceType,
  data: DataType<MediaLinkType | MomentLinkType | ArticleLinkType>,
  isSearchResult: boolean
) => {
  switch (type) {
    case ResourceType.ARTICLE:
      return (
        <ArticleLink
          data={data as DataType<ArticleLinkType>}
          isSearchResult={isSearchResult}
        />
      );
    case ResourceType.MEDIA:
      return (
        <MediaLink
          data={data as DataType<MediaLinkType>}
          isSearchResult={isSearchResult}
        />
      );
    case ResourceType.MOMENT:
      return (
        <MomentLink
          data={data as DataType<MomentLinkType>}
        />
      );
    default:
      return null;
  }
};

export const ResourceLink = ({
  data,
  type = ResourceType.MEDIA,
  isSearchResult = false,
}: ResourceLinkProps) => renderLinkComponent(type, data, isSearchResult);
